@use 'ui/styles/core-tokens' as core;

.notInstalled {
  display: flex;
  flex-direction: column;
  row-gap: 15px;
}

// inline-flex keeps the new-tab icon glued to the end of the link text
.notInstalledLink {
  display: inline-flex;
  align-items: center;
  column-gap: 4px;
}

.notInstalledFooter {
  display: flex;
  justify-content: center;
}
